import { render, staticRenderFns } from "./CalculatorHeading.vue?vue&type=template&id=7fdfa0ee&scoped=true&"
import script from "./CalculatorHeading.vue?vue&type=script&lang=js&"
export * from "./CalculatorHeading.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorHeading.vue?vue&type=style&index=0&id=7fdfa0ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdfa0ee",
  null
  
)

export default component.exports